<template>
  <div>
    <h2>^_^欢迎您！{{company}}</h2>
  </div>
</template>

<script>

  import {getStore} from "../../utils/util";

  export default {
    data() {
      return {
        list:[],
        company:''
      }
    },
    // 注册组件
    components: {

    },

    created() {
      this.load()
    },

    methods: {
      load() {
        this.company = getStore('company');
      },
    }
  }
</script>

<style scoped>
  .red{
    color:red
  }
</style>



// WEBPACK FOOTER //
// src/views/system/home.vue